<template>
  <div class="filter-item" :class="{ 'filter-item__open': open, 'filter-item__opened': opened }">
    <button type="button" class="filter-item__header" @click="open = opened || !open">
      <span class="filter-item__title">{{ title }}</span>
      <IconComponent v-if="!opened" name="arrow-down-1" />
    </button>
    <div class="filter-item__body" v-if="open">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import IconComponent from "components/IconComponent.vue";

export default {
  name: "FilterItemComponent",
  components: { IconComponent },
  props: {
    title: String,
    opened: Boolean,
  },
  data() {
    return {
      open: true,
    };
  },
};
</script>

<style lang="stylus">
.filter-item {
  display grid
  align-items start
  border-radius var(--small_radius)
  border 1px solid var(--gray)

  &__open &__header {
    border-bottom 1px solid var(--gray)

    .icon {
      transform rotate(180deg)
    }
  }

  &:not(&__opened) &__header {
    cursor pointer

    &:hover {
      color var(--main-color-75)
    }
  }

  &__header {
    padding 16px 20px
    display flex
    align-items center
    justify-content space-between
    border none
    background none
    font-weight: 700;
    font-size: 1.125em
    line-height: 140%;
    color: var(--main-color)

    .icon {
      width 12px
      height: 12px
    }
  }

  &__title {
    display: flex;
    align-items: center;
    text-align left
    transition color var(--transition)
  }
}
</style>
